export type MutateSearchParamOptions = {
  value: string | undefined;
  searchParam: URLSearchParams;
};

export function mutateSearchParam(
  key: string,
  { value, searchParam }: MutateSearchParamOptions
) {
  if (value) {
    searchParam.set(key, value);
  } else {
    searchParam.delete(key);
  }
}

export function parseToNumber(val: string) {
  return parseInt(val);
}
